// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".repateble-none .el-card__body>div:not(:first-child) label{display:none}.beneficiary .application-form .el-card__body{padding:1rem}.el-divider--horizontal{margin:0 0 16px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
